import { MouseEvent, useState } from 'react'
import { Button, Menu, MenuItem, ListItemIcon, ListItemText, MenuList } from '@vapor/material'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition, faHouseChimneyUser, faCheck, faHourglassHalf, faPen } from '@fortawesome/pro-regular-svg-icons'
import { HiCIcon } from 'src/app/components/icons/icon'
import { MenuActionType } from '../../../../../types/guests.types'
import { IconButton } from '@mui/material'

type PhaseSelectProps = {
  inHouse?: MenuActionType
  notYetArrived?: MenuActionType
  departed?: MenuActionType
}

export const PhaseSelect = (props: PhaseSelectProps) => {
  const { inHouse, notYetArrived, departed } = props
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const onMenuItemClick = (action: () => void) => {
    action()
    handleClose()
  }

  return (
    <>
      <IconButton color="primary" size="small" onClick={handleClick}>
        <FontAwesomeIcon icon={faPen} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuList>
          {inHouse && (
            <StyledMenuItem
              onClick={() => onMenuItemClick(inHouse.action)}
              icon={faHouseChimneyUser}
              text={t('pms.booking.reservation.guest.action.set_phase', { phase: t('pms.booking.reservation.frontend_phase.home') })}
              disabled={inHouse.disabled}
            />
          )}
          {notYetArrived && (
            <StyledMenuItem
              onClick={() => onMenuItemClick(notYetArrived.action)}
              icon={faHourglassHalf}
              text={t('pms.booking.reservation.guest.action.set_phase', { phase: t('pms.booking.reservation.frontend_phase.not_yet_arrived') })}
              disabled={notYetArrived.disabled}
            />
          )}
          {departed && (
            <StyledMenuItem
              onClick={() => onMenuItemClick(departed.action)}
              icon={faCheck}
              text={t('pms.booking.reservation.guest.action.set_phase', { phase: t('pms.booking.reservation.frontend_phase.departed') })}
              disabled={departed.disabled}
            />
          )}
        </MenuList>
      </Menu>
    </>
  )
}

const StyledMenuItem = (props: { onClick: React.MouseEventHandler<HTMLLIElement>; icon: IconDefinition; text: string; disabled?: boolean }) => {
  return (
    <MenuItem onClick={props.onClick} disabled={props.disabled}>
      <ListItemIcon>
        <HiCIcon>
          <FontAwesomeIcon icon={props.icon} size="sm" style={{ width: 20 }} />
        </HiCIcon>
      </ListItemIcon>
      <ListItemText>{props.text}</ListItemText>
    </MenuItem>
  )
}
